import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface ChiTieuThongKes {
  name: string;
  api_token: string;
}

export interface ChiTieuThongKesListInfor {
  errors: unknown;
  chiTieuThongKes: ChiTieuThongKes;
  isAuthenticated: boolean;
}

@Module
export default class ChiTieuThongKesModule
  extends VuexModule
  implements ChiTieuThongKesListInfor
{
  errors = {};
  chiTieuThongKes = {} as ChiTieuThongKes;
  isAuthenticated = !!JwtService.getToken();

  get ChiTieuThongKes() {
    return this.chiTieuThongKesListData;
  }

  @Mutation
  [Mutations.CHI_TIEU_THONG_KES_LIST_DATA](ChiTieuThongKes) {
    this.chiTieuThongKesListData = ChiTieuThongKes;
  }

  @Action
  [Actions.CHI_TIEU_THONG_KES_LIST](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("/chitieu_tk", payload)
        .then((data) => {
          this.context.commit(Mutations.CHI_TIEU_THONG_KES_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.CHI_TIEU_THONG_KE_CREATE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("chitieu_tk/upsert", payload)
        .then((data) => {
          this.context.commit(Mutations.CHI_TIEU_THONG_KES_LIST_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.CHI_TIEU_THONG_KE_UPDATE](payload) {
    const id = payload.get("id");
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.getDataDetail("/chitieu_tk", "upsert", id, payload)
        .then((data) => {
          this.context.commit(Mutations.CHI_TIEU_THONG_KES_LIST_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.CHI_TIEU_THONG_KE_DELETE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.getDataDetail("/chitieu_tk", payload, "delete", payload)
        .then((data) => {
          this.context.commit(Mutations.CHI_TIEU_THONG_KES_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }
}
